import AxiosService from "@/infra/http/axios";

const requestResetPasswordRepository = {
  /**
   * Envia e-mail para recuperar senha
   */
  async requestResetPassword(email: string) {
    const Instance = await AxiosService.createAxiosInstance();

    const response = await Instance.post(
      "/users/recuperar-senha",
      { email },
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
        },
      }
    );

    return response.data;
  },
};

export { requestResetPasswordRepository };
